<template>
        <div class="app-Recharge">
            <div class="ccpay-Recharge-header">
                <span @click="back"> 退後</span>
                <span >提現</span>
                <span></span>
             </div>
             <div class="cpay-Recharge-connect">
                 <div class="cpay-Recharge-tab">
                    <!-- <div :class="isactive=='ERC'?'active':''" @click="tabactive('ERC')">ERC-20</div>
                    <div :class="isactive=='OMNI'?'active':''" @click="tabactive('OMNI')">OMNI Layer</div> -->
                    <div :class="isactive=='TRC'?'active':''" @click="tabactive('TRC')">TRC-20</div>
                 </div>
                  <mt-field style="border-bottom: 1px solid #ccc;" class="phoneNum phoneNumTull-lv"   :placeholder="placeholder" type="tel" v-model="address"
                 ></mt-field> 
                   <mt-field style="border-bottom: 1px solid #ccc;" class="phoneNum phoneNumTull-lv"   placeholder="选择提币歷史" type="tel"  @click.native="clicklisaddress()"  
                 ></mt-field> 
                 <div style="border-bottom: 1px solid #ccc;height: 40px;line-height: 40px;">
                 <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="number" v-on:input="blur"   placeholder="请输入提币数量" type="number" 
                     
                 ></input>
                 </div>
                 <mt-field v-show="isactive=='ERC'" class="phoneNum phoneNumTull-lv" disabled  placeholder="手续费" type="tel"
                   :value="'手续费 '+ erc20fee +' USDT'" 
                 ></mt-field>
                 <mt-field v-show="isactive=='OMNI'" class="phoneNum phoneNumTull-lv" disabled    placeholder="手续费" type="tel"
                    :value="'手续费 '+ ominfee +' USDT'" 
                 ></mt-field>
                 <mt-field v-show="isactive=='TRC'" class="phoneNum phoneNumTull-lv" disabled  placeholder="手续费" type="tel"
                   :value="'手续费 '+ trc20fee +' USDT'" 
                 ></mt-field>
                  <mt-field v-show="isactive=='ERC'"
                 class="phoneNum phoneNumTull-lv" disabled  placeholder="实际到账数量" type="tel"
                    :value="'实际到账数量：' +  (number- erc20fee)<=0?'0':(number-erc20fee)" 
                 ></mt-field>
                 <mt-field  v-show="isactive=='OMNI'" class="phoneNum phoneNumTull-lv" disabled    placeholder="实际到账数量" type="tel"
                    :value="'实际到账数量：' +  (number - ominfee)<=0?'0':(number- ominfee) " 
                 ></mt-field>
                 <mt-field v-show="isactive=='TRC'"
                 class="phoneNum phoneNumTull-lv" disabled  placeholder="实际到账数量"
                    :value="'实际到账数量：' +  ((number - trc20fee)<0 ? '-' : (number- trc20fee)+ ' USDT') " 
                 ></mt-field>
                 <mt-button size="large" type="primary" @click.prevent="withdrawal('OMNI')" 
                     style='margin-bottom:2rem;margin-top:1rem' >提現</mt-button>
                 
                 <div class="cpay-Recharge-msg">
                     <p class="c8">提示</p>
                     
                      <p class="c8"  v-show="isactive=='ERC'"> 1、最小提币数量为 {{erc20minamout}} USDT</p>
                       <p class="c8"  v-show="isactive=='OMNI'"> 1、最小提币数量为 {{ omniminamout}} USDT</p>
                        <p class="c8"  v-show="isactive=='TRC'"> 1、最小提币数量为 {{ trc20minamout}} USDT</p>

                      <p class="c8"> 2、为确保您的資金安全，建议您于（上午08：00-凌晨2：00间）申请提币，其他時間提币将有所延缓。</p>

                      <p class="c8"> 3、请务必确认电脑及浏览器安全，防止資訊被篡改或泄露</p>

                      <p class="c8">  4、大额提現可能会由于跨链转换原因，延时到账，预计需要1-6个小时</p>
                      
                      <p class="c8"> 如有疑问，请联系客服</p>
                 </div>
                 <mt-popup
                 style="width:100%;text-align:center"
                v-model="popupVisible"
                position="bottom">
                <p style="padding-bottom:10px;padding-top:10px;border-bottom:1px solid #ccc;">请选择您的提币歷史</p>
                <p  style="padding-bottom:10px;padding-top:10px;border-bottom:1px solid #ccc;font-size:14px;"
                 v-for="(item,index) in popupVisibleddata" 
                 @click="clicklis(item.address)"
                 :index="index">{{item.address}}</p>
                </mt-popup>
             </div>
        </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
export default {
    data(){
        return{
            popupVisible:false,
            popupVisibleddata:['','','',''],
            locladdress:'',

            isactive:'TRC', //切换
            address:'', //地址
            // ethaddress:'',
            number:'', //数量
            symbol:'', //类型
            placeholder:'',
            datalist:null,
             omniminamout:11, //数量费率
            ominfee:10,
            erc20minamout:11,
            erc20fee:10,
            trc20minamout:4,
            trc20fee:3,
        }
    },
    mounted(){
        this.symbol  = 'USDT_TRC20'
        this.placeholder = "TRC-20 提現地址"
         this.$axios.get('/v1/account/amount_list').then(res=>{
                if(res.code==0){
                    this.datalist = res.data 
                     this.datalist.forEach((item,index)=>{
                        if(item.symbol=='USDT'){
                            this.omniminamout= parseInt(item.withdrawMin)
                            this.ominfee = parseInt(item.withdrawFee)
                        }
                        if(item.symbol=='ETH_USDT'){
                            this.erc20minamout= parseInt(item.withdrawMin)
                            this.erc20fee = parseInt(item.withdrawFee)
                        }
                        if(item.symbol=='USDT_TRC20'){
                            this.trc20minamout= parseInt(item.withdrawMin)
                            this.trc20fee = parseInt(item.withdrawFee)
                        }
                    })
                    console.log(res.data,'res.data')
                }else{
                    
                }
            })
    },
    methods:{
        clicklisaddress(){
            this.popupVisible = true
            if(this.isactive=='ERC'){
                  this.$axios.get('/v1/account/history_address?symbol=ETH_USDT',{
				                  
				     }).then(res=>{
				                    if(res.code==0){
                                            this.popupVisibleddata =res.data
				                    }else{
				                         this.popupVisibleddata =[]
				                    }
				    })
            }
            if(this.isactive=='OMNI'){
                this.$axios.get('/v1/account/history_address',{
									
					         }).then(res=>{
					                 if(res.code==0){
                                            this.popupVisibleddata =res.data
                                        }else{
                                            this.popupVisibleddata =[]
                                        }
					 })
            }
            if(this.isactive=='TRC'){
                this.$axios.get('/v1/account/history_address?symbol=TRX',{
					               
					      }).then(res=>{
					                if(res.code==0){
                                            this.popupVisibleddata =res.data
                                        }else{
                                            this.popupVisibleddata =[]
                                        }
					 })
            }
        },
        clicklis(address){
            this.address = address
             this.popupVisible = false
        },
        back(){
            this.$router.go(-1)
        },
        blur(){
            if(this.number==''){
                this.number = ''
                return
            }

            if(this.number<=0){
                this.number = 0
                return
            } 
           
            let a= this.number.toString().match(/^\d+(?:\.\d{0,4})?/)[0]
             this.number =  a
            //  console.log(this.number)
        },
        withdrawal(type){
             
            //判断提現地址
            if(this.isactive=='ERC'){
                if(/^0x[0-9a-fA-F]{38,69}$/.test(this.address)){
                       if(this.number< this.erc20minamout){
                            this.$Toast(`提現数量请大于${this.erc20minamout}`)
                            return
                        }
                }else{
                    this.$Toast('请输入正确提現地址')
                     return
                }
            }
            if(this.isactive=='OMNI'){
                if(/^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,69}$/.test(this.address)){
                     if(this.number<this.omniminamout){
                            this.$Toast(`提現数量请大于${this.omniminamout}`)
                            return
                        }
                }else{
                     this.$Toast('请输入正确提現地址')
                     return
                }
            }
            if(this.isactive=='TRC'){
                if(/^T.{20,40}$/.test(this.address)){
                    if(this.number<this.trc20minamout){
                            this.$Toast(`提現数量请大于${this.trc20minamout}`)
                            return
                        }
                }else{
                     this.$Toast('请输入正确提現地址')
                     return
                }
            }
            // if(this.number<100){
            //      this.$Toast('提現数量请大于100')
            //      return
            // }
            
            
            let obj = {
                data:{
                    "value":this.number,
                    "address":this.address,
                    "symbol":this.symbol
                }
            }
          
            window.localStorage.setItem('withdata',JSON.stringify(obj))

            this.$router.push({
                path:'/Cashaudit'
            })
            return
             Indicator.open();
            this.$axios.post('/v1/wallet/withdraw',obj).then(res=>{
                 Indicator.close();
                if(res.code==0){
                    this.$Toast('提現已申请')
                    this.address = ''
                    this.number = ''
                }else{
                     this.$Toast(res.msg)
                }
            })
        },
        //切换
        tabactive(type){
            this.isactive = type
            this.address = ''
            this.number = ''
            if(this.isactive=='ERC'){
                 this.symbol  = 'ETH_USDT'
                 this.placeholder = "ERC-20 提現地址"
            }else if(this.isactive=='OMNI'){
                 this.symbol  = 'BTC_USDT'
                 this.placeholder = "OMNI Layer 提現地址"
            }else{
                 this.symbol  = 'USDT_TRC20'
                 this.placeholder = "TRC-20 提現地址"
            }
            
        //    console.log(this.symbol)
        },
    }
}
</script>

<style lang="scss" scoped>
    .app-Recharge{
          height: 100%;;
          background: white;
        .ccpay-Recharge-header{
              
                background: white;
                display: flex;
                justify-content: space-between;
                padding: 1rem;
          
        }
        .cpay-Recharge-connect{
             background: white;
            padding: 1rem;
        }
        .cpay-Recharge-address{
             margin-bottom: 1rem;
        }
        .cpay-Recharge-tab{
             background: white;
            display: flex;
            justify-content: space-around;
            margin-bottom: 2rem;
            div{
                padding-bottom: 1rem;
            }
            .active{
                color: #20ABFE;
                 border-bottom: 1px solid #20ABFE;
            }
        }
        .cpay-Recharge-msg{
            p{
                line-height: 2rem;
            }
        }
        .app-Recharge-number{
                width: 300px;
             border: none;
            font-size: 16px;
            font-weight: 400 !important;
            font-family: inherit;
            line-height: 2.3rem !important;
            outline: none;
            padding: 0 10px;
            // margin-left: 0.4rem !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/CashWithdrawal.vue